<template>
  <div>
    <!--    <vue-perfect-scrollbar class="scroll-area">-->
    <div class="body">
      <slot name="body"/>
    </div>
    <!--    </vue-perfect-scrollbar>-->

    <div class="footer margin-top-10">
      <slot name="footer"/>
    </div>

  </div>
</template>
<script>
  import VuePerfectScrollbar from "vue-perfect-scrollbar";

  export default {
    name: "advance-search-form-layout",
    components: {VuePerfectScrollbar}
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/common/layout/advance-search-form-layout.vue